<mat-card>
  <h2 translate="add-account/common/choose"></h2>
  <form [formGroup]="form" (ngSubmit)="connect()">
    <mat-radio-group formControlName="rid">
      <mat-radio-button *ngFor="let page of pages" [value]="page.authorization_id" [disabled]="!page.can_be_authorized">
        <span
          [matTooltip]="'add-account/common/already-authorized' | translate"
          [matTooltipDisabled]="!page.authorization_id">
          {{ page.name }}
        </span>
        <a
          href="{{ page.url }}"
          target="_blank"
          rel="noopener noreferrer"
          [matTooltip]="'add-account/common/tooltip-see' | translate: { channel: prettyChannelName }">
          <mat-icon>help_outline</mat-icon>
        </a>
      </mat-radio-button>
    </mat-radio-group>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
      translate="add-account/common/connect"></button>
  </form>
</mat-card>
